var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "get-action": _vm.queryApi,
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          serial: true,
        },
        on: {
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("screenWMS.customer"),
                          prop: "customerList",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.customerListALL,
                            multiple: "",
                            placeholder: _vm.$t("customerNameText"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.customerList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "customerList", $$v)
                            },
                            expression: "queryParams.customerList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("screenWMS.type"),
                          prop: "typeList",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.typeAllList,
                            multiple: "",
                            placeholder: _vm.$t("screenWMS.type"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.typeList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "typeList", $$v)
                            },
                            expression: "queryParams.typeList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("screenWMS.Condition"),
                          prop: "conditionValue",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { placeholder: _vm.$t("screenWMS.Condition") },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.conditionValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "conditionValue", $$v)
                            },
                            expression: "queryParams.conditionValue",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.onAdd()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "customer"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerListALL.bjGet(
                                                scope.row.customer
                                              )
                                            )
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEdit(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("editText")))]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "delete-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDel(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("delText")))]
                                      ),
                                    ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogFormVisible,
            width: "600px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("screenWMS.customer"),
                            prop: "customer",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.customerListALL,
                              placeholder: _vm.$t("screenWMS.customer"),
                            },
                            on: { change: _vm.changeCustomer },
                            model: {
                              value: _vm.form.customer,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "customer", $$v)
                              },
                              expression: "form.customer",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("screenWMS.type"),
                            prop: "type",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              disabled: !_vm.form.customer,
                              "option-list": _vm.typeDialogList,
                              placeholder: _vm.$t("screenWMS.type"),
                            },
                            on: { change: _vm.clearConditionValue },
                            model: {
                              value: _vm.form.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "type", $$v)
                              },
                              expression: "form.type",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.type == "SKU" && _vm.isALL
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SKU", prop: "conditionValue" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "270px" },
                                  attrs: {
                                    "remote-method": _vm.remoteMethod,
                                    loading: _vm.loading,
                                    placeholder: "SKU",
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                  },
                                  model: {
                                    value: _vm.form.conditionValue,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "conditionValue", $$v)
                                    },
                                    expression: "form.conditionValue",
                                  },
                                },
                                _vm._l(_vm.options, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.type == "SKU" && !_vm.isALL
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SKU", prop: "conditionValue" } },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  "option-list": _vm.skuDialogList,
                                  placeholder: "SKU",
                                },
                                model: {
                                  value: _vm.form.conditionValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "conditionValue", $$v)
                                  },
                                  expression: "form.conditionValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.type == "Customer"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("screenWMS.customer"),
                                prop: "conditionValue",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  "option-list": _vm.customerDialogList,
                                  placeholder: _vm.$t("screenWMS.customer"),
                                },
                                model: {
                                  value: _vm.form.conditionValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "conditionValue", $$v)
                                  },
                                  expression: "form.conditionValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.type == "Address"
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("screenWMS.Enter"),
                                prop: "conditionValue",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  type: "textarea",
                                  rows: 5,
                                  maxlength: _vm.MAX_LENGTH.PRIORITY,
                                  "show-word-limit": "",
                                  autosize: "",
                                  placeholder: _vm.$t("screenWMS.Enter"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.conditionValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "conditionValue", $$v)
                                  },
                                  expression: "form.conditionValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSave()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }